import React, { Component, Fragment } from 'react';
import { Row, Col,  Button } from "reactstrap";
import { inject, observer } from 'mobx-react';
import { IconeInformacao } from '../../comum/components/Icones';
import * as moment from 'moment';
import ListaServicos from './ListaServicos';
import Tooltip from '../../comum/components/Tooltip';
import Card from '../../comum/components/Card';
import DetalhesRemContainer from './DetalhesRemContainer';
import { LoadingWhapper } from '../../comum/loading/components';
import AddServicosAcessorios from './AddServicosAcessorios';
import AddServicosQtdVariavel from './AddServicosQtdVariavel';
import InputRangeDate from '../../comum/tables/components/inputs/InputRangeDate';
import { E_TIPO_TELA } from '../stores/Enum';
import { toJS } from 'mobx';

@inject("store")
@observer
export default class DetalhesRemocoes extends Component {
    constructor(props) {
        super(props);

        this.dataStore = this.props.controllers.dataStore;
        this.remStore = this.props.controllers.remStore;
        this.filterStore = this.props.controllers.filterStore;
        this.viewStore = this.props.controllers.viewStore;
        this.modalStore = this.props.store.modalStoreCustom;
    }

    componentDidMount() {
        this.viewStore.simulacaoAtiva = true;
        this.remStore.fecthOptions(this.filterStore.tipoCliente);
        
        const containers = toJS(this.remStore.data.value.Containers);
        if (containers.length == 0) this.remStore.addContainer(this.filterStore.tipoCliente);
    }

    componentWillUnmount() {
        
     }

    handleGerarServicos = async () => {
        if (this.viewStore.servicosAtivo){
            this.remStore.resetarServicos();
            this.viewStore.servicosAtivo = false;
        }
        else {
            this.viewStore.servicosAtivo = true;

            const { error, message } = await this.remStore.gerarServicos(this.filterStore.filters);
    
            if (error) {
                this.viewStore.servicosAtivo = false;
                if (message) this.modalStore.openNewConfigurableModal('Alerta!', {
                    body: <p>{message}</p>,
                    hideCancel: true,
                })
            }
        }
    }

    handleConfirm = async () => {
        const modalSelect = this.modalStore.openNewConfigurableModal('Atenção', {
            body: <p dangerouslySetInnerHTML={{__html: 'Aguarde por favor!'}}></p>,
            hideCancel: true,
            loading: true,
        });

        const { status, title, message, dadosModalidade } = await this.remStore.calcularSimulacao(this.filterStore.filters);

        if (status == 200) {
            this.dataStore.dadosModalidade = dadosModalidade;
            this.viewStore.alteraTela(E_TIPO_TELA.ResultadoSimulacao);
        }
        
        modalSelect.appendConfigurableModal({
            title,
            body: <p dangerouslySetInnerHTML={{__html: message}}></p>,
            loading: false,
            hideCancel: true,
        });
    }

    render() {
        const ultimoDiaAno = moment().month() == 11 ? moment().add(1, 'year').endOf('year') : moment().endOf('year');

        return (
            <Col xs={12} sm={12} md={12} lg={12} xl={12} className="mt-3">
                <Row className="d-flex align-items-baseline justify-content-between px-3">
                    <h4>Simulação</h4>
                    <Button className="mb-1 btn-com-bordas-primary" onClick={this.handleGerarServicos} > 
                        {this.viewStore.servicosAtivo ? "Editar Serviços" : "Gerar Serviços"}                        
                    </Button>
                </Row>
                <Card className="pr-0">
                    <Row className="w-100">
                        <InputRangeDate xs={12} sm={12} md={6} lg={4} xl={4}
                            className={'pr-1'}
                            title="Data Entrada - Saída"
                            required={true}
                            error={this.remStore.data.value.Erros['DataEntrada'] || this.remStore.data.value.Erros['DataSaida']}
                            onChangeStart={(value)=>this.remStore.setItem('DataEntrada', value)}
                            onChangeEnd={(value)=>this.remStore.setItem('DataSaida', value)}
                            startDate={this.remStore.data.value.DataEntrada}
                            endDate={this.remStore.data.value.DataSaida}
                            isOutsideRange={day => !day.isAfter(moment()) || !day.isBefore(ultimoDiaAno)} 
                            disabled={this.viewStore.servicosAtivo}
                        />
                        <Tooltip 
                            tooltipText={(
                                <Fragment>
                                    Entrada: Data de descarga do container. <br/> <br/>
                                    Saída: Data de embarque do container.'
                                </Fragment>
                            )}
                            containerClassName="align-content-center"
                            style={{ width: 'max-content', marginTop: '-90px', marginLeft: '-80px', textAlign: 'left' }} bottom >
                            <IconeInformacao className="card-colorido--icone mt-1" />
                        </Tooltip>
                    </Row>
                    {this.remStore.data.value.Containers.map((cntr, index) => (
                        <Fragment key={index}>
                            <DetalhesRemContainer controllers={this.props.controllers} cntr={cntr} index={index}/>
                        </Fragment>
                    ))}
                    <Row className="ml-3 d-flex align-items-center">
                        <Button className="ml-3 mt-3 btn-com-bordas-primary" onClick={() => this.remStore.addContainer(this.filterStore.tipoCliente)} 
                            disabled={this.viewStore.servicosAtivo}>
                            + Adicionar Item
                        </Button>
                    </Row>
                </Card>

                {this.viewStore.servicosAtivo && 
                    <Fragment>
                        <Row className="d-flex align-items-baseline px-3 mt-4">
                            <h4>Serviços</h4>
                            <Col className="d-flex justify-content-end">
                                <AddServicosAcessorios
                                    className="mb-1 btn-com-bordas-primary" 
                                    controllers={this.props.controllers}
                                    tipoTela={E_TIPO_TELA.Remocoes}
                                    items={this.remStore.getAllItems()}
                                >
                                    + Serviços Acessórios
                                </AddServicosAcessorios>
                                <AddServicosQtdVariavel
                                    controllers={this.props.controllers}
                                    tipoTela={E_TIPO_TELA.Remocoes}
                                />
                            </Col>
                        </Row>
                        <Card className="px-3 pb-5">
                            <LoadingWhapper loading={this.remStore.loadingServicos} >
                                <ListaServicos dataStore={this.remStore}/>
                            </LoadingWhapper>
                        </Card>
                        {this.remStore.servicos.length > 0 &&
                            <div className="d-flex flex-column align-items-center justify-content-end mt-3">
                                <Col xs={12} sm={12} md={3} lg={3} xl={3} className="d-flex flex-row align-items-end">
                                    <Button size="lg" className="btn-com-bordas-primary btn-filtrar" 
                                        block
                                        onClick={this.handleConfirm}
                                    >
                                        Simular
                                    </Button>
                                </Col>
                            </div>
                        }
                    </Fragment>
                }
            </Col>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/components/DetalhesRemocoes.js